import React from "react";

export function MsgOnlyName({ name = "Cool guy" }) {
  return <h1 className="name">Hi, {name}😊!!!</h1>;
}
